//LOGIN
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const LOGIN_WITH_OTP = 'LOGIN_WITH_OTP';
export const LOGIN_WITH_OTP_SUCCESS = 'LOGIN_WITH_OTP_SUCCESS';
export const LOGIN_WITH_OTP_ERROR = 'LOGIN_WITH_OTP_ERROR';

export const FETCH_USER_ROLE = 'FETCH_USER_ROLE';
export const FETCH_USER_ROLE_SUCCESS = 'FETCH_USER_ROLE_SUCCESS';
export const FETCH_USER_ROLE_ERROR = 'FETCH_USER_ROLE_ERROR';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR';


//USERS

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_ERROR = 'GET_ALL_USERS_ERROR';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_ERROR = 'EDIT_USER_ERROR';

export const CHANGE_USER_STATUS = 'CHANGE_USER_STATUS';
export const CHANGE_USER_STATUS_SUCCESS = 'CHANGE_USER_STATUS_SUCCESS';
export const CHANGE_USER_STATUS_ERROR = 'CHANGE_USER_STATUS_ERROR';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

//SALES

//Category
export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY';
export const GET_ALL_CATEGORY_SUCCESS = 'GET_ALL_CATEGORY_SUCCESS';
export const GET_ALL_CATEGORY_ERROR = 'GET_ALL_CATEGORY_ERROR';

export const GET_CATEGORY_FOR_ALL = 'GET_CATEGORY_FOR';
export const GET_CATEGORY_FOR_ALL_SUCCESS = 'GET_CATEGORY_FOR_SUCCESS';
export const GET_CATEGORY_FOR_ALL_ERROR = 'GET_CATEGORY_FOR_ERROR';


//Services
export const GET_ALL_SERVICES = 'GET_ALL_SERVICES';
export const GET_ALL_SERVICES_SUCCESS = 'GET_ALL_SERVICES_SUCCESS';
export const GET_ALL_SERVICES_ERROR = 'GET_ALL_SERVICES_ERROR';

//Add Services
export const CREATE_SERVICES = 'CREATE_SERVICES';
export const CREATE_HELPDESK = 'CREATE_HELPDESK';
export const CREATE_SERVICES_SUCCCESS = 'CREATE_SERVICES_SUCCCESS';
export const CREATE_SERVICES_ERROR = 'CREATE_SERVICES_ERROR';

//Update Services Status
export const UPDATE_SERVICES_STATUS = 'UPDATE_SERVICES_STATUS';
export const UPDATE_SERVICES_STATUS_SUCCCESS = 'UPDATE_SERVICES_STATUS_SUCCCESS';
export const UPDATE_SERVICES_STATUS_ERROR = 'UPDATE_SERVICES_STATUS_ERROR';

//Update Services
export const UPDATE_SERVICES = 'UPDATE_SERVICES';
export const UPDATE_SERVICES_SUCCCESS = 'UPDATE_SERVICES_SUCCCESS';
export const UPDATE_SERVICES_ERROR = 'UPDATE_SERVICES_ERROR';

// Delete Service 
export const DELETE_SERVICES = 'DELETE_SERVICES';
export const DELETE_SERVICES_SUCCESS = 'DELETE_SERVICES_SUCCESS';
export const DELETE_SERVICES_ERROR = 'DELETE_SERVICES_ERROR';

//Change Status Active to Inactive
export const CHANGE_STATUS_SERVICES = 'CHANGE_STATUS_SERVICES';
export const CHANGE_STATUS_SERVICES_SUCCCESS = 'CHANGE_STATUS_SERVICES_SUCCCESS';
export const CHANGE_STATUS_SERVICES_ERROR = 'CHANGE_STATUS_SERVICES_ERROR';

//Change Status Inactive to Active
export const CHANGE_STATUS_SERVICES_TO_ACTIVE = 'CHANGE_STATUS_SERVICES_TO_ACTIVE';
export const CHANGE_STATUS_SERVICES_TO_ACTIVE_SUCCESS = 'CHANGE_STATUS_SERVICES_TO_ACTIVE_SUCCESS';
export const CHANGE_STATUS_SERVICES_TO_ACTIVE_ERROR = 'CHANGE_STATUS_SERVICES_TO_ACTIVE_ERROR';

//Countries
export const GET_ALL_COUNTRIES = 'GET_ALL_COUNTRIES';
export const GET_ALL_COUNTRIES_SUCCESS = 'GET_ALL_COUNTRIES_SUCCESS';
export const GET_ALL_COUNTRIES_ERROR = 'GET_ALL_COUNTRIES_ERROR';

//Taxes
export const GET_ALL_TAXES = 'GET_ALL_TAXES';
export const GET_ALL_TAXES_SUCCESS = 'GET_ALL_TAXES_SUCCESS';
export const GET_ALL_TAXES_ERROR = 'GET_ALL_TAXES_ERROR';

//Coupons
export const GET_ALL_COUPONS = 'GET_ALL_COUPONS';
export const GET_ALL_COUPONS_SUCCESS = 'GET_ALL_COUPONS_SUCCESS';
export const GET_ALL_COUPONS_ERROR = 'GET_ALL_COUPONS_ERROR';

export const CREATE_COUPONS = 'CREATE_COUPONS';
export const CREATE_COUPONS_SUCCESS = 'CREATE_COUPONS_SUCCESS';
export const CREATE_COUPONS_ERROR = 'CREATE_COUPONS_ERROR';

export const UPDATE_COUPONS_STATUS = 'UPDATE_COUPONS_STATUS';
export const UPDATE_COUPONS_STATUS_SUCCESS = 'UPDATE_COUPONS_STATUS_SUCCESS';
export const UPDATE_COUPONS_STATUS_ERROR = 'UPDATE_COUPONS_STATUS_ERROR';

export const UPDATE_COUPONS = 'UPDATE_COUPONS';
export const UPDATE_COUPONS_SUCCESS = 'UPDATE_COUPONS_SUCCESS';
export const UPDATE_COUPONS_ERROR = 'UPDATE_COUPONS_ERROR';

//Change Status Active to Inactive
export const CHANGE_STATUS_COUPONS = 'CHANGE_STATUS_COUPONS';
export const CHANGE_STATUS_COUPONS_SUCCESS = 'CHANGE_STATUS_COUPONS_SUCCESS';
export const CHANGE_STATUS_COUPONS_ERROR = 'CHANGE_STATUS_COUPONS_ERROR';

//Change Status Inactive to Active
export const CHANGE_STATUS_COUPONS_TO_ACTIVE = 'CHANGE_STATUS_COUPONS_TO_ACTIVE';
export const CHANGE_STATUS_COUPONS_TO_ACTIVE_SUCCESS = 'CHANGE_STATUS_COUPONS_TO_ACTIVE_SUCCESS';
export const CHANGE_STATUS_COUPONS_TO_ACTIVE_ERROR = 'CHANGE_STATUS_COUPONS_TO_ACTIVE_ERROR';


//Products
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_ERROR = 'GET_ALL_PRODUCTS_ERROR';

//Policies
export const GET_POLICIES= 'GET_POLICIES';
export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS';
export const GET_POLICIES_ERROR = 'GET_POLICIES_ERROR';


//AFFILIATIONS

//clients-Companies

export const GET_ALL_COMPANIES = 'GET_ALL_COMPANIES';
export const GET_ALL_COMPANIES_SUCCCESS = 'GET_ALL_COMPANIES_SUCCCESS';
export const GET_ALL_COMPANIES_ERROR = 'GET_ALL_COMPANIES_ERROR';

//Dealers-Dealerships

export const GET_ALL_DEALERSHIPS_LOADING = 'GET_ALL_DEALERSHIPS_LOADING';
export const GET_ALL_DEALERSHIPS = 'GET_ALL_DEALERSHIPS';
export const GET_ALL_DEALERSHIPS_SUCCCESS = 'GET_ALL_DEALERSHIPS_SUCCCESS';
export const GET_ALL_DEALERSHIPS_ERROR = 'GET_ALL_DEALERSHIPS_ERROR';

//Dealers-DealershipsUsers

export const GET_ALL_DEALERSHIPS_USERS = 'GET_ALL_DEALERSHIPS_USERS';
export const GET_ALL_DEALERSHIPS_USERS_SUCCCESS = 'GET_ALL_DEALERSHIPS_USERS_SUCCCESS';
export const GET_ALL_DEALERSHIPS_USERS_ERROR = 'GET_ALL_DEALERSHIPS_USERS_ERROR';

//Manufacturers - Brands

export const GET_ALL_BRANDS = 'GET_ALL_BRANDS';
export const GET_ALL_BRANDS_SUCCCESS = 'GET_ALL_BRANDS_SUCCCESS';
export const GET_ALL_BRANDS_ERROR = 'GET_ALL_BRANDS_ERROR';

//Manufacturers - Fuel

export const GET_FUEL = 'GET_FUEL';
export const GET_FUEL_SUCCCESS = 'GET_FUEL_SUCCCESS';
export const GET_FUEL_ERROR = 'GET_FUEL_ERROR';

//Manufacturers - transmission

export const GET_ALL_TRANSMISSION = 'GET_ALL_TRANSMISSION';
export const GET_ALL_TRANSMISSION_SUCCCESS = 'GET_ALL_TRANSMISSION_SUCCCESS';
export const GET_ALL_TRANSMISSION_ERROR = 'GET_ALL_TRANSMISSION_ERROR';

//Manufacturers - Models

export const GET_ALL_MODELS = 'GET_ALL_MODELS';
export const GET_ALL_MODELS_SUCCCESS = 'GET_ALL_MODELS_SUCCCESS';
export const GET_ALL_MODELS_ERROR = 'GET_ALL_MODELS_ERROR';

//Manufacturers - Variants

export const GET_ALL_VARIANTS = 'GET_ALL_VARIANTS';
export const GET_ALL_VARIANTS_SUCCCESS = 'GET_ALL_VARIANTS_SUCCCESS';
export const GET_ALL_VARIANTS_ERROR = 'GET_ALL_VARIANTS_ERROR';

//DMS data

export const GET_ALL_DMS_DATA = 'GET_ALL_DMS_DATA';
export const GET_ALL_DMS_DATA_SUCCCESS = 'GET_ALL_DMS_DATA_SUCCCESS';
export const GET_ALL_DMS_DATA_ERROR = 'GET_ALL_DMS_DATA_ERROR';

//Navision 

//Admin Wallet
//Wallet Refund
export const GET_ALL_ADMIN_WALLET_DATA = 'GET_ALL_ADMIN_WALLET_DATA';
export const GET_ALL_ADMIN_WALLET_DATA_SUCCCESS = 'GET_ALL_ADMIN_WALLET_DATA_SUCCCESS';
export const GET_ALL_WALLET_REFUND_DATA = 'GET_ALL_WALLET_REFUND_DATA';
export const GET_ALL_WALLET_REFUND_DATA_SUCCCESS = 'GET_ALL_WALLET_REFUND_DATA_SUCCCESS';
export const GET_ALL_NAVISION_DATA_ERROR = 'GET_ALL_NAVISION_DATA_ERROR';


/* TODO APP*/
export const WATCH_TODO_LIST = "WATCH_TODO_LIST";
export const GET_TODO_LIST = "GET_TODO_LIST";
export const GET_LIST_SUCCESS = "GET_LIST_SUCCESS";
export const MARK_ALL_ITEMS = "MARK_ALL_ITEMS";
export const ADD_NEW_ITEM = "ADD_NEW_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const SELECTED_ITEM = "SELECTED_ITEM";

/* ECOMMERRCE APP */
export const GET_LIST = "GET_LIST";
export const WATCH_PRODUCT_LIST = "WATCH_PRODUCT_LIST";
export const WATCH_SINGLE_ITEM = "WATCH_SINGLE_ITEM"
export const GET_ALL_PRODUCT = "GET_ALL_PRODUCT";
export const GET_SINGLE_ITEM = "GET_SINGLE_ITEM";
export const DECREMENT_QTY = "DECREMENT_QTY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";

/* Bookmark App */
export const WATCH_BOOKMARK_LIST = "WATCH_BOOKMARK_LIST"
export const GET_BOOKMARK_LIST = "GET_BOOKMARK_LIST"
export const ADD_TO_MY_BOOKMARK = "ADD_TO_MY_BOOKMARK"
export const ADD_NEW_BOOKMARK = "ADD_NEW_BOOKMARK"
export const REMOVE_BOOKMARK = "REMOVE_BOOKMARK"
export const REMOVE_FROM_MY_BOOKMARK = "REMOVE_FROM_MY_BOOKMARK"
export const UPDATE_BOOKMARK = "UPDATE_BOOKMARK"
export const UPDATE_MY_BOOKMARK = "UPDATE_MY_BOOKMARK"

// Project 
export const ADD_NEW_PROJECT = "ADD_NEW_PROJECT"


/* Task App */

export const WATCH_TASK_LIST = "WATCH_TASK_LIST"
export const FETCH_ALL_TASK = "FETCH_ALL_TASK"
export const NEW_TASK = "NEW_TASK"
export const REMOVE_TASK = "REMOVE_TASK"

/* Cart */
export const ADD_TO_CART = 'ADD_TO_CART';

/* Wishlist */
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';

/* Filters */
export const FILTER_BRAND = 'FILTER_BRAND';
export const FILTER_COLOR = 'FILTER_COLOR';
export const FILTER_PRICE = 'FILTER_PRICE';
export const SEARCH_BY = 'SEARCH_BY';
export const SORT_BY = 'SORT_BY';

/* CHAT APP */
export const GET_MEMBERS = "GET_MEMBERS";
export const WATCH_CHAT_MEMBERS = "WATCH_CHAT_MEMBERS";
export const WATCH_CHAT_SUCCESS = "WATCH_CHAT_SUCCESS";
export const WATCH_ALL_CHAT_SUCCESS = "WATCH_ALL_CHAT_SUCCESS";
export const GET_MEMBERS_SUCCESS = "GET_MEMBERS_SUCCESS";
export const GET_CHATS = "GET_CHATS";
export const GET_CHATS_SUCCESS = "GET_CHATS_SUCCESS";
export const UPDATE_SELECTED_USER = "UPDATE_SELECTED_USER";
export const CHANGE_CHAT = "CHANGE_CHAT";
export const CREATE_CHAT = "CREATE_CHAT";
export const CREATE_CHAT_WATCHER = "CREATE_CHAT_WATCHER";
export const SEARCH_MEMBER = "SEARCH_MEMBER";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const SEND_MESSAGE_WATCHER = "SEND_MESSAGE_WATCHER";
export const REPLY_BY_SELECTED_USER = "REPLY_BY_SELECTED_USER";
export const REPLY_MESSAGE_WATCHER = "REPLY_MESSAGE_WATCHER"

/* Email-app */
export const WATCH_EMAIL = "WATCH_EMAIL";
export const WATCH_ALL_TYPE_EMAIL = "WATCH_ALL_TYPE_EMAIL";
export const GET_ALL_EMAIL_ASYN = "GET_ALL_EMAIL_ASYN";
export const GET_ALL_TYPE_ASYN = "GET_ALL_TYPE_ASYN";
export const GET_EMAILS = "GET_EMAILS";
export const GET_ALL_EMAILS = "GET_ALL_EMAILS";
export const GET_EMAIL_TYPES = "GET_EMAIL_TYPES";
export const UPDATE_EMAIL_TYPES = "UPDATE_EMAIL_TYPES";


/* CUSTOMIZER */
export const WATCH_CUSTOMIZER ="WATCH_CUSTOMIZER";
export const ADD_COSTOMIZER ="ADD_COSTOMIZER";
export const ADD_LAYOUT = "ADD_LAYOUT";
export const ADD_SIDEBAR_TYPES = "ADD_SIDEBAR_TYPES";
export const ADD_SIDEBAR_SETTINGS ="ADD_SIDEBAR_SETTINGS";
export const ADD_COLOR = "ADD_COLOR";
export const ADD_MIX_BACKGROUND_LAYOUT = "ADD_MIX_BACKGROUND_LAYOUT";
export const ROUTER_ANIMATION = "ROUTER_ANIMATION";

//policy
// export const UPDATE_PAYLOAD = "UPDATE_KYC";
export const UPDATE_POLICY_PAYLOAD = "UPDATE_POLICY";
export const UPDATE_POLICY_PAYLOAD_SUCCESS = "UPDATE_POLICY_SUCCESS";
export const UPDATE_POLICY_PAYLOAD_RESET = "UPDATE_POLICY_RESET";
export const UPDATE_POLICY_PAYLOAD_ERROR = "UPDATE_POLICY_ERROR";


//wallet 
export const GET_WALLET_BALANCE = "GET_WALLET_BALANCE";
export const GET_WALLET_BALANCE_SUCCESS = "GET_WALLET_BALANCE_SUCCESS";
export const GET_WALLET_BALANCE_RESET = "GET_WALLET_BALANCE_RESET";
export const GET_WALLET_BALANCE_ERROR = "GET_WALLET_BALANCE_ERROR";

// KYC
export const UPDATE_KYC_PAYLOAD = "UPDATE_KYC";
export const UPDATE_KYC_PAYLOAD_SUCCESS = "UPDATE_KYC_SUCCESS";
export const UPDATE_KYC_PAYLOAD_RESET = "UPDATE_KYC_RESET";
export const UPDATE_KYC_PAYLOAD_ERROR = "UPDATE_KYC_ERROR";
export const SET_DEALER_PAN_NSDL_VERIFY = "SET_DEALER_PAN_NSDL_VERIFY";
export const SET_DEALER_GSTN_VERIFY = "SET_DEALER_GSTN_VERIFY";
export const SET_DEALER_MSME_VERIFY = "SET_DEALER_MSME_VERIFY";

//Cashify policy
export const UPDATE_CASHIFY_POLICY_PAYLOAD = "UPDATE_CASHIFY_POLICY";
export const UPDATE_CASHIFY_POLICY_PAYLOAD_SUCCESS = "UPDATE_CASHIFY_POLICY_SUCCESS";
export const UPDATE_CASHIFY_POLICY_PAYLOAD_RESET = "UPDATE_CASHIFY_POLICY_RESET";
export const UPDATE_CASHIFY_POLICY_PAYLOAD_ERROR = "UPDATE_CASHIFY_POLICY_ERROR";



//bulk policy
export const UPDATE_BULK_POLICY_PAYLOAD = "UPDATE_BULK_POLICY";
export const UPDATE_BULK_POLICY_PAYLOAD_SUCCESS = "UPDATE_BULK_POLICY_SUCCESS";
export const UPDATE_BULK_POLICY_PAYLOAD_RESET = "UPDATE_BULK_POLICY_RESET";
export const UPDATE_BULK_POLICY_PAYLOAD_ERROR = "UPDATE_BULK_POLICY_ERROR";
export const SAVE_VALIDATION_DATA = "SAVE_VALIDATION_DATA";
export const SAVE_DISCOUNT_DATA = "SAVE_DISCOUNT_DATA";
export const UPDATE_DISCOUNTED_RECORDS = "UPDATE_DISCOUNTED_RECORDS";
export const CLEAR_DISCOUNT_DATA = "CLEAR_DISCOUNT_DATA";
export const UPDATE_VALIDATION_RECORDS = "UPDATE_VALIDATION_RECORDS";
export const SAVE_PROPOSER_DETAILS = "SAVE_PROPOSER_DETAILS";
export const SAVE_BULK_FILE_URL = "SAVE_BULK_FILE_URL";
export const SAVE_BULK_QUOTATION_NUMBER = "SAVE_BULK_QUOTATION_NUMBER";
export const SAVE_ADDON_DATA = "SAVE_ADDON_DATA";
export const CLEAR_ADDON_DATA = "CLEAR_ADDON_DATA";
//scan me

// Action type constant for setting scanme data in the store
export const SET_SCANME_DATA = 'SET_SCANME_DATA';
export const RESET_SCANME_DATA = 'RESET_SCANME_DATA'; // To clear the data



//LOGOUT


export const LOGOUT = 'LOGOUT';